import { render, staticRenderFns } from "./model2.vue?vue&type=template&id=4dc86d47&scoped=true"
import script from "./model2.vue?vue&type=script&lang=js"
export * from "./model2.vue?vue&type=script&lang=js"
import style0 from "./model2.vue?vue&type=style&index=0&id=4dc86d47&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc86d47",
  null
  
)

export default component.exports